<template>
  <v-app>
    
    <div class="bg">
    </div>
    <v-main>
      <v-container fill-height>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-card 
              elevation="24" 
              shaped 
              style="background-color: rgba(0, 0, 0, 0.5);"
            >
            <div class="d-flex justify-center pb-8">
              <v-img
              lazy-src="@/assets/logo_dream.png"
              src="@/assets/logo_dream.png"
              max-width="250"
              ></v-img>
            </div>
            <h1 class="h1 pb-8 text-center" style="color:white;">C4 - Bem vindo de volta</h1>
            <validation-observer
              ref="login"
              v-slot="{ invalid, dirty }"
            >
              <v-form @submit.prevent="submit">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                    <validation-provider name="Email\Username" vid="username" rules="required" v-slot="{ errors }">
                      <v-text-field class="text-white" v-model="username" label="Email\Username" prepend-inner-icon="mdi-account" :error-messages="errors"></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                    <validation-provider name="Password" vid="password" rules="required" v-slot="{ errors }">
                      <v-text-field class="text-white" v-model="password" type="password" label="Password" prepend-inner-icon="mdi-lock" :error-messages="errors"></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                    <v-btn
                      depressed
                      color="primary"
                      class="mr-4"
                      type="submit"
                      :disabled="invalid && !dirty"
                      large
                      block
                    >
                      Login
                    </v-btn>
                    
                    <v-col cols="12" md="12">
                    <v-btn
                      block
                      class="mt-4"
                      outlined
                      small
                      dark
                      @click="microsoftLogin"
                    >
                      <v-icon>mdi-microsoft</v-icon>
                      {{ $msal.isAuthenticated() ? user.userName : 'Usar conta Microsoft' }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="12">
                      <v-btn
                        dark
                        block
                        outlined
                        small
                        @click="$msal.signOut()"
                        v-if="$msal.isAuthenticated()"
                      >
                        <v-icon>mdi-logout</v-icon>
                        Logout
                      </v-btn>
                    </v-col> 

                    <v-btn
                      text
                      color="primary"
                      class="mr-4 mt-4"
                      type="button"
                      block
                      @click="reset_password.opened = !reset_password.opened"
                    >
                      Esqueci-me da password
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </validation-observer>
            <div class="d-flex justify-center mb-5 mt-5">
              <v-img
              lazy-src="@/assets/dreamdeal.png"
              src="@/assets/dreamdeal.png"
              max-width="150"
              ></v-img>
            </div>
            <div class="d-flex justify-center">
              <span class="body-2 mr-3" style="color:white;">Powered By <a href="https://www.dreamdealtech.pt/">Dreamdeal Technologies</a></span>
              
              <v-img v-if="false"
              lazy-src="@/assets/logo_dream.png"
              src="@/assets/logo_dream.png"
              max-width="80"
              ></v-img>
            </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
      <v-dialog
        v-model="reset_password.opened"
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="h5">Reset Password</span>
          </v-card-title>
          <v-card-text>
            <validation-observer v-if="!reset_password.reseted" ref="reset" v-slot="{ invalid }">
              <v-form @submit.prevent="reset">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" vid="email" name="Email" rules="required|email">
                        <v-text-field
                          v-model="reset_password.email"
                          prepend-inner-icon="mdi-at"
                          label="Email"
                          type="email"
                          clearable
                          :error-messages="errors"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row class="mt-6" align="center" justify="space-around">
                    <v-col align="center" justify="space-around">
                      <v-btn :disabled="invalid" depressed color="primary" class="mr-5 ml-5 mb-5" type="submit">
                        Enviar email
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </validation-observer>
            <v-container v-else>
              <v-row>
                <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                  <h2 class="success--text text-center">Email enviado!</h2>
                  <v-row class="mt-6" align="center" justify="space-around">
                    <v-icon
                      large
                      class="text-center"
                      color="success"
                    >
                      mdi-checkbox-marked-circle-outline
                    </v-icon>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="reset_password.opened = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-app>
</template>
<style>
 .text-white input {
    color: white !important;
  }
.text-white label {
  color: white !important;
}
.text-white i {
  color: white !important;
}
.text-white v-messages__wrapper{
  color: white !important;
}
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 1;
    top: 0;
    left: 0;
    background: url( '../assets/imagem_login.jpg') no-repeat center center;
    background-size: cover;
    background-color: red;
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
    transform: scale(1.1);
  }
  </style>
<script>
import User from "@/api/User.js"
import { msalMixin } from 'vue-msal'; 

export default {
  components: {
  },
  mixins: [msalMixin],
  data: () => ({
    username: "",
    password: "",
    reset_password: {
      opened: false,
      email: "",
      reseted: false,
    }
  }),
  beforeCreate(){
    document.title = "Hefesto- Login";

    if(localStorage['auth'] == 1){
      this.$router.push('/admin');
    }
  },
  mounted(){
    let cookieLogin = this.$cookies.get('login-try');

    if(cookieLogin){
      if(this.$msal.isAuthenticated()){
        User.microsoftLogin(this.$msal.data.user.userName, this.$msal.data.user.idToken.oid)
            .then(({data}) => {

                if(data.two_factor){
                  this.$router.push('/2fa');

                  return;
                }

                localStorage['auth'] = 1;

                this.$cookies.remove('login-try');

                this.$router.push('/admin');
            }).catch(err => {

              if(err.response.status == 422) {

                this.$refs.login.setErrors(err.response.data.errors);
                
                return;
              }
          });
        }
    }
  },
  methods:{
    async microsoftLogin(){
      this.$cookies.set('login-try', true);

      if(this.$msal.isAuthenticated()){
        User.microsoftLogin(this.$msal.data.user.userName, this.$msal.data.user.idToken.oid)
            .then(({data}) => {

                if(data.two_factor){
                  this.$router.push('/2fa');

                  return;
                }

                localStorage['auth'] = 1;

                this.$cookies.remove('login-try');

                this.$router.push('/admin');
            }).catch(err => {

              if(err.response.status == 422) {

                this.$refs.login.setErrors(err.response.data.errors);
                
                return;
              }
          });
        }else{
          this.$msal.signIn()
        }
    },
    submit () {
        this.$refs.login.validate().then((valid) => {
          if (!valid) {
            return;
          }

          User.logout(this.$root.session == undefined ? null : this.$root.session.id)
            .then(() => {
              this.login();
            }).catch(() => {
              this.login();
            })
        });
      },
      login(){
        this.password = this.$encryptValue(this.password);
        User.login(this.username, this.password)
          .then(({data}) => {

              if(data.two_factor){
                this.$router.push('/2fa');

                return;
              }

              localStorage['auth'] = 1;

              this.$router.push('/admin');
          }).catch(err => {

            if(err.response.status == 422) {

              this.$refs.login.setErrors(err.response.data.errors);
              
              return;
            }
        });
      },
      reset () {
        this.$refs.reset.validate().then((valid) => {
          if (!valid) {
            return;
          }

          User.reset(this.reset_password.email)
            .then(() => {

                this.reset_password.reseted = true;
            }).catch(err => {

              if(err.response.status == 422) {

                this.$refs.reset.setErrors(err.response.data.errors);
                
                return;
              }

              this.reset_password.reseted = false;

          });
        });
      },
  },
  computed: {
      user() {
        let user = null;
        if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
          user = {
            ...this.msal.user,
            profile: {}
          }
          if (this.msal.graph && this.msal.graph.profile) {
              user.profile = this.msal.graph.profile
          }
        }
        
        return user;
      }
  }
};
</script>
